import React, { useState } from 'react';
import { WindowStackItem } from '../../context/window-stack/WindowStackItem';
import { WindowBody } from '../window/partials/WindowBody';
import { WindowHeader } from '../window/partials/WindowHeader';
import { Window } from '../window/Window';
import { UploadMethodsProps } from './CreateUploadMethod';
import { UploadMethodComponent } from './partials/UploadMethodComponent';
import { UploadMethods } from './UploadMethods';
import styles from './UploadMethods.module.scss';

export const UploadMethodsInline = ({
    uploadMethodsClassName,
    methods, onUpload
}: Props) => {

    const [activeSource, setActiveSource] = useState<keyof UploadMethodsProps>('Dropzone');
    const closeWindow = () => setActiveSource('Dropzone');

    return (
        <div>
            <UploadMethods
                onUpload={onUpload}
                close={closeWindow}
                className={uploadMethodsClassName}
                methods={methods}
                setActiveSource={setActiveSource} />

            {activeSource !== 'Dropzone' && (
                <WindowStackItem>
                    <Window className={styles.window}
                        close={closeWindow}
                        size='sm' mobileOrigin='center'>
                        <WindowHeader onClose={closeWindow} />
                        <WindowBody>
                            <UploadMethodComponent
                                onUpload={onUpload}
                                close={closeWindow}
                                method={methods[activeSource]!} />
                        </WindowBody>
                    </Window>
                </WindowStackItem>
            )}
        </div>
    );
};

export type Props = {
    methods: UploadMethodsProps;
    uploadMethodsClassName?: string;
    onUpload?: () => void;
};